export default {
  computed: {
    godFatherCode(){
        if (document.cookie.split(';').filter((item) => item.includes('sider-godFatherCode')).length) {
            return document.cookie.split(';').filter((item) => item.includes('sider-godFatherCode'))[0].split('=')[1];
        }
        return "";
    },
  }
}